import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {Path} from '../common/path';
import {RestResult} from '../models/response/rest-result';
import {UserRequest} from '../models/request/user-request';
import {CommonService} from './common.service';
import {SearchRequest} from '../models/request/search-request';

@Injectable()
export class UserService {

  constructor(protected http: HttpClient,
              protected commonService: CommonService) {
  }

  getOne(userId: number): Observable<RestResult> {
    return this.http.get<any>(
      Path.API_ENDPOINT +
      Path.USER +
      Path.USER_ID.replace(':userId', userId.toString())
    ).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError)
    );
  }


  search(request: SearchRequest): Observable<RestResult> {
    return this.http.post<any>(
      Path.API_ENDPOINT +
      Path.USER +
      Path.SEARCH, request
    ).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError)
    );
  }

  register(request: UserRequest): Observable<RestResult> {
    return this.http.post<any>(
      Path.API_ENDPOINT +
      Path.USER +
      Path.REGISTER, request).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError)
    );
  }

  remove(userId: number): Observable<RestResult> {
    return this.http.delete<any>(
      Path.API_ENDPOINT +
      Path.USER +
      Path.USER_ID.replace(':userId', userId.toString())
    ).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError)
    );
  }

  update(request: UserRequest): Observable<RestResult> {
    return this.http.put<any>(
      Path.API_ENDPOINT +
      Path.USER, request).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError)
    );
  }
}
